const LegendaryHeroes_Scuba = [
  { name: "scuba1", url: require("./jfhLegendary_009.jpg") },
  { name: "scuba2", url: require("./jfhLegendary_010.jpg") },
  { name: "scuba3", url: require("./jfhLegendary_011.jpg") },
  { name: "scuba4", url: require("./jfhLegendary_012.jpg") },
];
export default LegendaryHeroes_Scuba;
